import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, ArrowRight, Activity } from 'lucide-react';

const LandingPage: React.FC = () => {
  const [inputId, setInputId] = useState('');
  const navigate = useNavigate();

  const handleGo = (e: React.FormEvent) => {
    e.preventDefault();
    if (inputId.trim()) {
      navigate(`/view/${inputId.trim()}`);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center p-6 text-slate-200">
      <div className="max-w-md w-full space-y-8">
        
        {/* Logo Section */}
        <div className="text-center">
          <div className="inline-flex items-center justify-center p-4 bg-slate-800 rounded-full mb-6 border border-slate-700 shadow-xl shadow-cyan-900/20">
            <Activity className="w-10 h-10 text-cyan-400" />
          </div>
          <h1 className="text-4xl font-bold tracking-tight text-white mb-2">SensorLink</h1>
          <p className="text-slate-400 text-lg">Secure, private home monitoring.</p>
        </div>

        {/* Action Box */}
        <div className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-2xl border border-slate-700 shadow-xl">
          <form onSubmit={handleGo} className="space-y-4">
            <div>
              <label htmlFor="access-id" className="block text-sm font-medium text-slate-400 mb-2">
                Have a Personal Access ID?
              </label>
              <input
                id="access-id"
                type="text"
                placeholder="e.g. user123"
                value={inputId}
                onChange={(e) => setInputId(e.target.value)}
                className="w-full px-4 py-3 bg-slate-900 border border-slate-600 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 text-white placeholder-slate-500 outline-none transition-all"
              />
            </div>
            <button
              type="submit"
              className="w-full flex items-center justify-center gap-2 bg-cyan-500 hover:bg-cyan-400 text-slate-900 font-bold py-3 px-4 rounded-xl transition-all active:scale-95"
            >
              Access Dashboard
              <ArrowRight className="w-5 h-5" />
            </button>
          </form>
        </div>

        {/* Footer Info */}
        <div className="text-center space-y-4">
          <div className="flex items-center justify-center gap-2 text-sm text-slate-500">
            <ShieldCheck className="w-4 h-4" />
            <span>End-to-End Encrypted & Private</span>
          </div>
          <p className="text-xs text-slate-600">
            Don't have an ID? Contact your administrator.
          </p>
        </div>

      </div>
    </div>
  );
};

export default LandingPage;